<!-- 小结 -->
<template>
  <div class="TableSummary">
    <div class="search-container">
      <div class="search-item">
        <a-select
          v-model:value="queryParam.type"
          placeholder="选择类型"
          style="width: 224px"
          size="large"
          allowClear
          :options="summaryTypeMap"
        />
      </div>
      <div class="search-item">
        <a-select
          v-model:value="queryParam.createByIdentityType"
          placeholder="选择添加人"
          style="width: 224px"
          size="large"
          allowClear
          :options="summaryAddMap"
        />
      </div>
      <div class="search-item">
        <a-range-picker
          size="large"
          v-model:value="dateList"
          :placeholder="['开始日期', '结束日期']"
          allowClear
          format="YYYY-MM-DD"
          :ranges="rangePresets"
          dropdownClassName="creatTime"
          :disabledDate="disabledDate"
        />
      </div>
      <div class="search-item">
        <a-button class="search-button" size="large" type="primary" @click="searchList">
          搜索
        </a-button>
      </div>
    </div>
    <a-table
      class="my-table"
      :transformCellText="({ text }) => text ?? '--'"
      :bordered="true"
      :pagination="pagination"
      :dataSource="dataSource"
      :columns="col"
      @change="change"
      :loading="loading"
      :rowKey="(_, index) => index"
      :scroll="{ x: '1300px' }"
    >
      <template #workOrderIds="{ record, text: workOrderIds }">
        <!--
        预问诊：3
        AI生成：2,4,5,6,7,8,9
        虚拟电话：10
        医助创建：0
        -->
        <div v-if="[0].includes(record.type)">
          医助创建
          <span v-if="workOrderIds && workOrderIds.length">
            ,工单id:
            <span v-for="(item, index) in workOrderIds" :key="item">
              <a-button @click="viewDetails(item)" type="link" size="small">{{ item }}</a-button>
              <span v-if="index !== workOrderIds.length - 1">、</span>
            </span>
          </span>
        </div>
        <div v-else-if="[10].includes(record.type)">
          虚拟电话,通话记录id:
          <a-button
            @click="rowDetail(record, 2)"
            type="link"
            size="small"
            v-for="it in record.cdrIds"
            :key="it"
          >
            {{ it }}
          </a-button>
        </div>
        <span v-else-if="[2, 4, 5, 6, 7, 8, 9].includes(record.type)">由AI生成</span>
        <span v-else>--</span>
      </template>
      <template #parentSns="{ record }">
        <template v-if="record.parentSns?.length">
          <a-button
            @click="openDetail(item)"
            v-for="item in record.parentSns"
            :key="item"
            type="link"
            size="small"
          >
            {{ item }}
          </a-button>
        </template>
        <template v-else>--</template>
      </template>
      <template #operation="{ record }">
        <a-button type="link" @click="rowDetail(record, 0)">查看详情</a-button>
        <a-button v-if="hasEdit(record)" type="link" @click="editDetail(record)">编辑</a-button>
      </template>
      <template #dialIntentStr="{ record }">
        {{ record?.dialIntentStr || '--' }}
      </template>
      <template #actualIntentStr="{ record }">
        {{ record?.actualIntentStr || '--' }}
      </template>
    </a-table>
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
      :scroll="{ y: 300 }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible.value = false"
        :active="summaryPannelActive"
      />
    </a-modal>
    <!-- 关联工单 -->
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
    <EditSummary ref="editSummaryRef" />
    <!-- 弹出框 -->
    <the-detail
      v-model:visible="detail.visible"
      :id="detail.id"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
    />
  </div>
</template>

<script setup>
import TheDetail from '@/components/TheDetail/index.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { workOrderDetail } from '@/api/Todo'
import { getCurSummaryList, getCurSummaryListV2, getSummaryInfo } from '@/api/workPlace/summary'
import { ColSummary as col } from '@/components/PatientFile/config'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'
import { computed, ref, watch, defineExpose, reactive } from 'vue'
import { useStore } from 'vuex'
import {
  getTimeRange,
  summaryAddMap,
  summaryTimeMap,
  summaryTypeMap,
  rangePresets,
  disabledDate,
  formatDateForFilter
} from '@/components/PatientFile/ModalBody/tags/PlatformService/config'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import { subStringToType } from '@/utils'

const store = useStore()
const ucPatientId = computed(() => store.state.patientFile.info.ucPatientId)
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)

const detail = reactive({
  visible: false,
  id: '',
  serialNumber: '',
  recordType: 'prescriptionGroup'
})
const dataSource = ref([])
const loading = ref(false)
const dateList = ref([])
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const queryParam = {
  type: '',
  createByIdentityType: ''
}
const summaryPanelVisible = ref(false)
const summaryPannelActive = ref(0)
const chatSummaryId = ref('')
const showAllDialog = ref(false)
const currentInfo = ref({})
const searchList = () => {
  getData()
}
const getData = async () => {
  const query = {
    currPage: pagination.value.current,
    pageSize: pagination.value.pageSize,
    ucPatientId: patientType.value ? ucPatientId.value : null,
    prePatientId: patientType.value === 0 ? info.value.prePatientId : null,
    ...queryParam
  }
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  query.startTime = startTime
  query.endTime = endTime
  dataSource.value = []
  loading.value = true
  // const params = new URLSearchParams()

  getCurSummaryListV2(query)
    .then(result => {
      const { list, totalCount } = result
      pagination.value.total = totalCount
      dataSource.value = list
      pagination.value.showTotal = () => `共${totalCount}条`
    })
    .catch(err => {})
    .finally(() => {
      loading.value = false
    })
}
const viewDetails = workOrderId => {
  workOrderDetail({ workOrderId }).then(res => {
    const { workOrder = {} } = res || {}
    showAllDialog.value = true
    currentInfo.value = workOrder
  })
}
const rowDetail = (record, active = 0) => {
  chatSummaryId.value = record.chatSummaryId
  summaryPanelVisible.value = true
  summaryPannelActive.value = active
}
const editSummaryRef = ref()
const editDetail = record => {
  getSummaryInfo({ chatSummaryId: record.chatSummaryId }).then(res => {
    const params = {
      privateId: res.groupId,
      groupInfo: res,
      isEdit: true,
      type: res.type,
      aiSummaryContents: res.type === 1 ? JSON.parse(res.contents) : res.content,
      workOrderId: res.workOrderIds
    }
    editSummaryRef.value?.initModal(params)
  })
}
const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getData()
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
watch(
  info,
  info => {
    if (info.ucPatientId || info.prePatientId) {
      change()
    }
  },
  { immediate: true }
)
defineExpose({ change })
// 是否展示 编辑按钮
const hasEdit = record => {
  let is = false
  // 只读状态
  // if (props.mode === 'read') return false
  // 0 是人工小结，1是导诊结果。
  // if ([0, 1].includes(record.type)) {
  //   is = true
  // }
  // 自己修改的可编辑
  if (record.type === 10 && record.createBy === store.getters.userId) {
    is = true
  }
  // ai 编辑的可以修改
  else if (record.isAiCallOut && record.createBy === 0) {
    return true
  }
  return is
}
const openDetail = serialNumber => {
  detail.recordType = subStringToType(serialNumber)
  detail.serialNumber = serialNumber
  detail.visible = true
}
</script>

<style lang="scss" scoped>
// .TableSummary {
// }
.search-container {
  // padding: 10px 20px 0 0;
  background-color: #ffffff;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search-input {
      width: 224px;
    }
  }
}
.src {
  display: flex;
  flex-wrap: wrap;
}
</style>
